import { MemoryRouter as Router, Routes, Route } from 'react-router-dom';
import './App.scss';
import './onlineChat.css';
import './theme.scss';
// import './tw.scss';

import { context } from './components/contex';
import React, { useContext, useEffect, useState } from 'react';
import AdminContextProvider, { AdminContext } from './context/AdminContext';
import Layout from './components/Layout';

export default function App({ electron = true }) {
  const [state, setState] = useState(false);

  return (
    <AdminContextProvider>
      <Layout electron={electron} />
    </AdminContextProvider>
  );
}
